<script>
import { mapGetters } from "vuex";
export default {
  name: "VideoPlay",
  data() {
    return {
      status: this.$store.state.user.user.live_open
    };
  },
  computed: {
    ...mapGetters(["live_open"]),
  }
};
</script>

<template>
  <div class="video-play" @click="$router.push('/curriculums/broadcast')">
    <img src="@/assets/h-icons/video-play.png" class="icon">
    <div class="status-tip" v-if="live_open == 1"></div>
  </div>
</template>

<style lang="scss" scoped>
.video-play {
  position: relative;
  width: 26px;
  height: 26px;
  cursor: pointer;

  .icon {
    width: 100%;
    height: 100%;
  }

  .status-tip {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 12px;
    height: 12px;
    border: 3px #FFF solid;
    background-color: #e14248;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ccc;
  }
}
</style>
